// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__MZJDv","loader":"Loader_loader__N0t16","spin":"Loader_spin__stP-V"};